import { push } from "connected-react-router";
import * as types from "./actionTypes";
import { hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import { toggleLoader } from "./loaderActions";
import serviceService from "../services/serviceService";

export function loadServiceSuccess(services) {
  return {
    type: types.LOAD_SERVICE_SUCCESS,
    services,
    meta: {
      throttle: true
    }
  };
}

export function getServiceSuccess(service) {
  return {
    type: types.GET_SERVICE_SUCCESS,
    service
  };
}

export function savingService(status = true) {
  return {
    type: types.SAVING_SERVICE,
    savingService: status
  };
}

export function createServiceSuccess(service) {
  return {
    type: types.CREATE_SERVICE_SUCCESS,
    service
  };
}

export function updateServiceSuccess(service) {
  return {
    type: types.UPDATE_SERVICE_SUCCESS,
    service
  };
}

export function loadServices() {
  return async (dispatch) => {
    await dispatch(toggleLoader(true));
    return serviceService
      .loadServices()
      .then(async (data) => {
        await dispatch(loadServiceSuccess(data));
        await dispatch(toggleLoader(false));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
  };
}

export function getService(id, goToPage = false) {
  return (dispatch) =>
    serviceService
      .getService(id)
      .then((service) => {
        dispatch(getServiceSuccess(service));
        if (goToPage) {
          dispatch(push(`/app/settings/services/${id}`));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createService(service) {
  return (dispatch) => {
    dispatch(savingService());
    return serviceService
      .createService(service)
      .then((createdService) => {
        dispatch(createServiceSuccess(createdService));
        dispatch(savingService(false));
        dispatch(showAlertSuccess("Service created successfully", "success"));
        dispatch(push(`/app/settings/services/${createdService._id}`));
      })
      .catch((error) => {
        dispatch(savingService(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function createServiceTask(id, task) {
  return (dispatch) => {
    dispatch(savingService());
    return serviceService
      .createTask(id, task)
      .then(() => {
        dispatch(getService(id));
        dispatch(savingService(false));
        dispatch(showAlertSuccess("Task created successfully", "success"));
        dispatch(hideModalSuccess("taskModal"));
      })
      .catch((error) => {
        dispatch(savingService(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function removeServiceTask(serviceId, taskId) {
  return (dispatch) => {
    dispatch(savingService());
    return serviceService
      .deleteTask(serviceId, taskId)
      .then(() => {
        dispatch(getService(serviceId));
        dispatch(savingService(false));
        dispatch(hideModalSuccess("taskModal"));
        dispatch(showAlertSuccess("Task updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingService(false));
        dispatch(showAlertSuccess(error, "error"));
      });
  };
}

export function updateService(service) {
  return (dispatch) => {
    dispatch(savingService());
    return serviceService
      .updateService(service)
      .then((updatedService) => {
        dispatch(updateServiceSuccess(updatedService));
        dispatch(savingService(false));
        dispatch(hideModalSuccess("serviceDetailsModal"));
        dispatch(showAlertSuccess("Service updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingService(false));
        dispatch(showAlertSuccess(error, "error"));
      });
  };
}
